import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { Post } from '../../types/types';
import PostItem from '../PostItem';
import NoticiasIcon from '../../images/noticias.svg';

const StyledSidebarNewsContainer = styled.div`
  margin-bottom: 1rem;
  .noticias-header {
    display: flex;
    margin-bottom: 1rem;
    text-transform: uppercase;
    font-family: 'TradeGothic Gold20';
    align-items: center;
    font-size: 1.4rem;
    img {
      width: 1.5rem;
      height: 1.5rem;
      margin-right: 0.5rem;
      position: relative;
      top: -0.2rem;
    }
  }
  .post-item-container {
    &:first-child {
      margin-top: 0;
    }
  }
`;

type SidebarNewsProps = {
  newsPosts: Post[];
  postId: string;
};

const SidebarNews = ({ newsPosts, postId }: SidebarNewsProps) => {
  const [displayedNewsPosts, setDisplayedNewsPosts] = useState<Post[]>([]);

  useEffect(() => {
    const tmpdisplayedNewsPosts: Post[] = [];

    newsPosts.forEach((post: Post) => {
      if (tmpdisplayedNewsPosts.length < 5 && post.id !== postId) {
        tmpdisplayedNewsPosts.push(post);
      }
    });
    setDisplayedNewsPosts(tmpdisplayedNewsPosts);
  }, []);

  return (
    <StyledSidebarNewsContainer>
      <div className="noticias-header">
        <img alt="Icono de noticias" src={NoticiasIcon} />
        <h3>Noticias</h3>
      </div>
      <div className="post-noticias">
        {displayedNewsPosts.length > 0 &&
          displayedNewsPosts.map((newPost: Post, index: number) => {
            return (
              <div key={newPost.id} className="post-item-container">
                <PostItem
                  noImage
                  noReadButton
                  onlyRead
                  isLastItem={index === displayedNewsPosts.length - 1}
                  post={newPost}
                />
              </div>
            );
          })}
      </div>
    </StyledSidebarNewsContainer>
  );
};

export default SidebarNews;
